import { render, staticRenderFns } from "./UPLoginPage.vue?vue&type=template&id=56ca6f66&scoped=true&"
import script from "./UPLoginPage.vue?vue&type=script&lang=js&"
export * from "./UPLoginPage.vue?vue&type=script&lang=js&"
import style0 from "./UPLoginPage.vue?vue&type=style&index=0&id=56ca6f66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca6f66",
  null
  
)

export default component.exports